/**
 * Centralized icon registry.
 *
 * Default format (array): stroke-based, viewBox 0 0 24 24
 *   'icon-name': [ { tag, attrs, text? }, ... ]
 *
 * Extended format (object): custom viewBox / fill-based icons
 *   'icon-name': { viewBox: '...', fill: true, d: [ { tag, attrs }, ... ] }
 */
export const icons = {
  // ── Inline SVG replacements ──────────────────────────────────

  eye: [
    { tag: 'path', attrs: { d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' } },
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 3 } },
  ],
  'eye-off': [
    { tag: 'path', attrs: { d: 'M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24' } },
    { tag: 'line', attrs: { x1: 1, y1: 1, x2: 23, y2: 23 } },
  ],
  'alert-circle': [
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 10 } },
    { tag: 'line', attrs: { x1: 12, y1: 8, x2: 12, y2: 12 } },
    { tag: 'line', attrs: { x1: 12, y1: 16, x2: 12.01, y2: 16 } },
  ],
  x: [
    { tag: 'line', attrs: { x1: 18, y1: 6, x2: 6, y2: 18 } },
    { tag: 'line', attrs: { x1: 6, y1: 6, x2: 18, y2: 18 } },
  ],
  'dollar-sign': {
    viewBox: '-5 0 19 19',
    fill: true,
    d: [
      { tag: 'path', attrs: { d: 'M8.699 11.907a3.005 3.005 0 0 1-1.503 2.578 4.903 4.903 0 0 1-1.651.663V16.3a1.03 1.03 0 1 1-2.059 0v-1.141l-.063-.011a5.199 5.199 0 0 1-1.064-.325 3.414 3.414 0 0 1-1.311-.962 1.029 1.029 0 1 1 1.556-1.347 1.39 1.39 0 0 0 .52.397l.002.001a3.367 3.367 0 0 0 .648.208h.002a4.964 4.964 0 0 0 .695.084 3.132 3.132 0 0 0 1.605-.445c.5-.325.564-.625.564-.851a1.005 1.005 0 0 0-.245-.65 2.06 2.06 0 0 0-.55-.44 2.705 2.705 0 0 0-.664-.24 3.107 3.107 0 0 0-.65-.066 6.046 6.046 0 0 1-1.008-.08 4.578 4.578 0 0 1-1.287-.415A3.708 3.708 0 0 1 1.02 9.04a3.115 3.115 0 0 1-.718-1.954 2.965 2.965 0 0 1 .321-1.333 3.407 3.407 0 0 1 1.253-1.335 4.872 4.872 0 0 1 1.611-.631V2.674a1.03 1.03 0 1 1 2.059 0v1.144l.063.014h.002a5.464 5.464 0 0 1 1.075.368 3.963 3.963 0 0 1 1.157.795A1.03 1.03 0 0 1 6.39 6.453a1.901 1.901 0 0 0-.549-.376 3.516 3.516 0 0 0-.669-.234l-.066-.014a3.183 3.183 0 0 0-.558-.093 3.062 3.062 0 0 0-1.572.422 1.102 1.102 0 0 0-.615.928 1.086 1.086 0 0 0 .256.654l.002.003a1.679 1.679 0 0 0 .537.43l.002.002a2.57 2.57 0 0 0 .703.225h.002a4.012 4.012 0 0 0 .668.053 5.165 5.165 0 0 1 1.087.112l.003.001a4.804 4.804 0 0 1 1.182.428l.004.002a4.115 4.115 0 0 1 1.138.906l.002.002a3.05 3.05 0 0 1 .753 2.003z' } },
    ],
  },
  'shopping-cart': [
    { tag: 'path', attrs: { d: 'M3 11l1.5-8h15L21 11M3 11h18M3 11v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9' } },
    { tag: 'circle', attrs: { cx: 8.5, cy: 16, r: 1.5 } },
    { tag: 'circle', attrs: { cx: 15.5, cy: 16, r: 1.5 } },
  ],
  'credit-card': [
    { tag: 'rect', attrs: { x: 2, y: 4, width: 20, height: 16, rx: 2 } },
    { tag: 'line', attrs: { x1: 2, y1: 10, x2: 22, y2: 10 } },
    { tag: 'line', attrs: { x1: 7, y1: 15, x2: 10, y2: 15 } },
    { tag: 'line', attrs: { x1: 13, y1: 15, x2: 17, y2: 15 } },
  ],
  'calendar-week': [
    { tag: 'rect', attrs: { x: 3, y: 4, width: 18, height: 18, rx: 2 } },
    { tag: 'line', attrs: { x1: 16, y1: 2, x2: 16, y2: 6 } },
    { tag: 'line', attrs: { x1: 8, y1: 2, x2: 8, y2: 6 } },
    { tag: 'line', attrs: { x1: 3, y1: 10, x2: 21, y2: 10 } },
    { tag: 'text', attrs: { x: 12, y: 18, 'text-anchor': 'middle', 'font-size': 7, fill: 'currentColor', stroke: 'none', 'font-weight': 700 }, text: '7' },
  ],
  truck: [
    { tag: 'rect', attrs: { x: 1, y: 3, width: 15, height: 13, rx: 2 } },
    { tag: 'path', attrs: { d: 'M16 8h4l3 5v4h-7V8z' } },
    { tag: 'circle', attrs: { cx: 5.5, cy: 18.5, r: 2.5 } },
    { tag: 'circle', attrs: { cx: 18.5, cy: 18.5, r: 2.5 } },
  ],
  monitor: [
    { tag: 'rect', attrs: { x: 2, y: 3, width: 20, height: 14, rx: 2 } },
    { tag: 'line', attrs: { x1: 8, y1: 21, x2: 16, y2: 21 } },
    { tag: 'line', attrs: { x1: 12, y1: 17, x2: 12, y2: 21 } },
  ],
  bell: [
    { tag: 'path', attrs: { d: 'M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9' } },
    { tag: 'path', attrs: { d: 'M13.73 21a2 2 0 0 1-3.46 0' } },
  ],

  // ── Sidebar menu icons (from SVG symbol sprites) ─────────────

  'ic-dashboard': [
    { tag: 'rect', attrs: { x: 3, y: 3, width: 7, height: 7, rx: 1 } },
    { tag: 'rect', attrs: { x: 14, y: 3, width: 7, height: 7, rx: 1 } },
    { tag: 'rect', attrs: { x: 3, y: 14, width: 7, height: 7, rx: 1 } },
    { tag: 'rect', attrs: { x: 14, y: 14, width: 7, height: 7, rx: 1 } },
  ],
  'ic-chart': [
    { tag: 'polyline', attrs: { points: '22 12 18 12 15 21 9 3 6 12 2 12' } },
  ],
  'trending-up': [
    { tag: 'polyline', attrs: { points: '23 6 13.5 15.5 8.5 10.5 1 18' } },
    { tag: 'polyline', attrs: { points: '17 6 23 6 23 12' } },
  ],
  'trending-down': [
    { tag: 'polyline', attrs: { points: '23 18 13.5 8.5 8.5 13.5 1 6' } },
    { tag: 'polyline', attrs: { points: '17 18 23 18 23 12' } },
  ],
  tag: [
    { tag: 'path', attrs: { d: 'M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z' } },
    { tag: 'line', attrs: { x1: 7, y1: 7, x2: 7.01, y2: 7 } },
  ],
  percent: [
    { tag: 'line', attrs: { x1: 19, y1: 5, x2: 5, y2: 19 } },
    { tag: 'circle', attrs: { cx: 6.5, cy: 6.5, r: 2.5 } },
    { tag: 'circle', attrs: { cx: 17.5, cy: 17.5, r: 2.5 } },
  ],
  calendar: [
    { tag: 'rect', attrs: { x: 3, y: 4, width: 18, height: 18, rx: 2 } },
    { tag: 'line', attrs: { x1: 16, y1: 2, x2: 16, y2: 6 } },
    { tag: 'line', attrs: { x1: 8, y1: 2, x2: 8, y2: 6 } },
    { tag: 'line', attrs: { x1: 3, y1: 10, x2: 21, y2: 10 } },
  ],
  'ic-mail': [
    { tag: 'rect', attrs: { x: 2, y: 4, width: 20, height: 16, rx: 2 } },
    { tag: 'polyline', attrs: { points: '2,4 12,13 22,4' } },
  ],
  'ic-users': [
    { tag: 'path', attrs: { d: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' } },
    { tag: 'circle', attrs: { cx: 9, cy: 7, r: 4 } },
    { tag: 'path', attrs: { d: 'M23 21v-2a4 4 0 0 0-3-3.87' } },
    { tag: 'path', attrs: { d: 'M16 3.13a4 4 0 0 1 0 7.75' } },
  ],
  'ic-pipeline': [
    { tag: 'polyline', attrs: { points: '16 3 21 3 21 8' } },
    { tag: 'line', attrs: { x1: 4, y1: 20, x2: 21, y2: 3 } },
    { tag: 'polyline', attrs: { points: '21 16 21 21 16 21' } },
    { tag: 'line', attrs: { x1: 15, y1: 15, x2: 21, y2: 21 } },
  ],
  'ic-segment': [
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 10 } },
    { tag: 'line', attrs: { x1: 2, y1: 12, x2: 22, y2: 12 } },
    { tag: 'path', attrs: { d: 'M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z' } },
  ],
  'ic-cases': [
    { tag: 'rect', attrs: { x: 2, y: 7, width: 20, height: 14, rx: 2 } },
    { tag: 'path', attrs: { d: 'M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2' } },
  ],
  'ic-auto': [
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 3 } },
    { tag: 'path', attrs: { d: 'M19.07 4.93l-1.41 1.41M4.93 4.93l1.41 1.41M19.07 19.07l-1.41-1.41M4.93 19.07l1.41-1.41M12 2v2M12 20v2M2 12h2M20 12h2' } },
  ],
  'ic-social': [
    { tag: 'rect', attrs: { x: 2, y: 2, width: 20, height: 20, rx: 2 } },
    { tag: 'path', attrs: { d: 'M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z' } },
    { tag: 'line', attrs: { x1: 17.5, y1: 6.5, x2: 17.51, y2: 6.5 } },
  ],
  // A page with lines of text: the website's stories (Website blog).
  'ic-blog': [
    { tag: 'path', attrs: { d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' } },
    { tag: 'path', attrs: { d: 'M14 2v6h6' } },
    { tag: 'line', attrs: { x1: 8, y1: 13, x2: 16, y2: 13 } },
    { tag: 'line', attrs: { x1: 8, y1: 17, x2: 13, y2: 17 } },
  ],
  'ic-location': [
    { tag: 'path', attrs: { d: 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z' } },
    { tag: 'circle', attrs: { cx: 12, cy: 10, r: 3 } },
  ],
  'ic-crm': [
    { tag: 'line', attrs: { x1: 18, y1: 20, x2: 18, y2: 10 } },
    { tag: 'line', attrs: { x1: 12, y1: 20, x2: 12, y2: 4 } },
    { tag: 'line', attrs: { x1: 6, y1: 20, x2: 6, y2: 14 } },
  ],
  'ic-menu': [
    { tag: 'path', attrs: { d: 'M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z' } },
    { tag: 'path', attrs: { d: 'M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z' } },
  ],
  'ic-products': [
    { tag: 'path', attrs: { d: 'M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z' } },
    { tag: 'line', attrs: { x1: 3, y1: 6, x2: 21, y2: 6 } },
    { tag: 'path', attrs: { d: 'M16 10a4 4 0 0 1-8 0' } },
  ],
  'ic-modifier': [
    { tag: 'line', attrs: { x1: 4, y1: 6, x2: 20, y2: 6 } },
    { tag: 'line', attrs: { x1: 4, y1: 12, x2: 20, y2: 12 } },
    { tag: 'line', attrs: { x1: 4, y1: 18, x2: 20, y2: 18 } },
  ],
  'ic-ops': [
    { tag: 'rect', attrs: { x: 2, y: 3, width: 20, height: 14, rx: 2 } },
    { tag: 'line', attrs: { x1: 8, y1: 21, x2: 16, y2: 21 } },
    { tag: 'line', attrs: { x1: 12, y1: 17, x2: 12, y2: 21 } },
  ],
  'ic-stock': [
    { tag: 'path', attrs: { d: 'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' } },
  ],
  'ic-vendor': [
    { tag: 'path', attrs: { d: 'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z' } },
    { tag: 'polyline', attrs: { points: '9 22 9 12 15 12 15 22' } },
  ],
  'ic-invoice': [
    { tag: 'path', attrs: { d: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' } },
    { tag: 'polyline', attrs: { points: '14 2 14 8 20 8' } },
    { tag: 'line', attrs: { x1: 16, y1: 13, x2: 8, y2: 13 } },
    { tag: 'line', attrs: { x1: 16, y1: 17, x2: 8, y2: 17 } },
  ],
  'ic-loyalty': [
    { tag: 'polygon', attrs: { points: '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2' } },
  ],
  'ic-settings': [
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 3 } },
    { tag: 'path', attrs: { d: 'M19.07 4.93l-1.41 1.41M4.93 4.93l1.41 1.41M12 2v2M12 20v2M2 12h2M20 12h2M17.66 17.66l-1.41-1.41M6.34 6.34l-1.41-1.41' } },
  ],
  'ic-gift': [
    { tag: 'polyline', attrs: { points: '20 12 20 22 4 22 4 12' } },
    { tag: 'rect', attrs: { x: 2, y: 7, width: 20, height: 5 } },
    { tag: 'line', attrs: { x1: 12, y1: 22, x2: 12, y2: 7 } },
    { tag: 'path', attrs: { d: 'M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z' } },
    { tag: 'path', attrs: { d: 'M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z' } },
  ],
  'ic-flash': [
    { tag: 'polygon', attrs: { points: '13 2 3 14 12 14 11 22 21 10 12 10 13 2' } },
  ],
  // Website blog editor (views/WebsiteBlog)
  image: [
    { tag: 'rect', attrs: { x: 3, y: 3, width: 18, height: 18, rx: 2 } },
    { tag: 'circle', attrs: { cx: 8.5, cy: 8.5, r: 1.5 } },
    { tag: 'polyline', attrs: { points: '21 15 16 10 5 21' } },
  ],
  images: [
    { tag: 'rect', attrs: { x: 3, y: 3, width: 7, height: 7, rx: 1 } },
    { tag: 'rect', attrs: { x: 14, y: 3, width: 7, height: 7, rx: 1 } },
    { tag: 'rect', attrs: { x: 14, y: 14, width: 7, height: 7, rx: 1 } },
    { tag: 'rect', attrs: { x: 3, y: 14, width: 7, height: 7, rx: 1 } },
  ],
  heading: [
    { tag: 'polyline', attrs: { points: '4 7 4 4 20 4 20 7' } },
    { tag: 'line', attrs: { x1: 9, y1: 20, x2: 15, y2: 20 } },
    { tag: 'line', attrs: { x1: 12, y1: 4, x2: 12, y2: 20 } },
  ],
  paragraph: [
    { tag: 'line', attrs: { x1: 21, y1: 6, x2: 3, y2: 6 } },
    { tag: 'line', attrs: { x1: 17, y1: 10, x2: 3, y2: 10 } },
    { tag: 'line', attrs: { x1: 21, y1: 14, x2: 3, y2: 14 } },
    { tag: 'line', attrs: { x1: 17, y1: 18, x2: 3, y2: 18 } },
  ],
  upload: [
    { tag: 'path', attrs: { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' } },
    { tag: 'polyline', attrs: { points: '17 8 12 3 7 8' } },
    { tag: 'line', attrs: { x1: 12, y1: 3, x2: 12, y2: 15 } },
  ],
  'external-link': [
    { tag: 'path', attrs: { d: 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6' } },
    { tag: 'polyline', attrs: { points: '15 3 21 3 21 9' } },
    { tag: 'line', attrs: { x1: 10, y1: 14, x2: 21, y2: 3 } },
  ],
  'chevron-left': [
    { tag: 'polyline', attrs: { points: '15 18 9 12 15 6' } },
  ],
  'chevron-right': [
    { tag: 'polyline', attrs: { points: '9 18 15 12 9 6' } },
  ],
};
